export const SERVER =
  "http://18.217.42.86:8000/api/v1/private/listing/create_draft";
export var listing_id;

function edit(id) {
  return (listing_id = id || localStorage.getItem("listing_id"));
}

export default edit;
